import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCurrentlyWatchingStyle0 = cosmosIconCss;

const CosmosIconCurrentlyWatching$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCurrentlyWatching extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '69eae8629960c51df27a0754070d35c851df6a27', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e13f8cc4e253368310d379bc4ec53007a6572958', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e5ea06a73bcf79af23f08292df9c79ee7824565f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.51 4.42a.52.52 0 0 1 .72 0v-.04a9.14 9.14 0 0 1-.09 13.1.5.5 0 0 1-.71 0l-.34-.35a.5.5 0 0 1 0-.71 7.66 7.66 0 0 0 .08-10.94.49.49 0 0 1 0-.7l.34-.36Zm-1.28 6.52a4.69 4.69 0 0 1-1.36 3.26.49.49 0 0 0 0 .71l.36.36a.51.51 0 0 0 .7 0 6.21 6.21 0 0 0 1.8-4.33A6.2 6.2 0 0 0 15 6.68a.51.51 0 0 0-.71 0l-.36.32a.5.5 0 0 0 0 .71 4.66 4.66 0 0 1 1.3 3.23ZM8 7c-2.4 0-4.24 1.44-5.66 3.71a.52.52 0 0 0 0 .54C3.76 13.56 5.62 15 8 15c2.38 0 4.27-1.42 5.67-3.71a.55.55 0 0 0 0-.54C12.26 8.46 10.42 7 8 7Zm0 1.52c1.54 0 2.87.82 4.05 2.49A4.87 4.87 0 0 1 8 13.48 4.86 4.86 0 0 1 4 11a4.92 4.92 0 0 1 4-2.48ZM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCurrentlyWatchingStyle0; }
}, [1, "cosmos-icon-currently-watching", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-currently-watching"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-currently-watching":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCurrentlyWatching$1);
            }
            break;
    } });
}

const CosmosIconCurrentlyWatching = CosmosIconCurrentlyWatching$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCurrentlyWatching, defineCustomElement };
